import React, { useState, useEffect } from 'react'
import Widget from '../../dpe-usco/components/Widget/Widget'
import _ from 'lodash'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'

const EstimatedUnits = ({ fields, root, loadingStatus }) => {
  let [weightedAverage, setWeightedAverage] = useState(0)
  let [totalAcres, setTotalAcres] = useState(0)
  let [totalSeed, setTotalSeed] = useState(0)
  let [unitsNeeded, setUnitsNeeded] = useState(null)
  const [UNIT_SIZE, setUnitSize] = useState(80000)

  useEffect(() => {
    if (root && root.contract_type === 'generic') {
      setUnitSize(140000)
    }
    if (fields.length) {
      let arrayOfSeedCount = []
      let arrayOfAcres = []
      fields.forEach(item => {
        arrayOfSeedCount.push(_.toNumber(item.acres) * _.toNumber(item.planting_rate))
        arrayOfAcres.push(_.toNumber(item.acres))
      })
      setTotalAcres(_.sum(arrayOfAcres))
      setTotalSeed(_.sum(arrayOfSeedCount))
      setWeightedAverage(Math.round((totalSeed / totalAcres) * 100) / 100 || 0)
      setUnitsNeeded(Math.ceil(totalSeed / UNIT_SIZE) || '')
    } else {
      setWeightedAverage(0)
      setUnitsNeeded(null)
    }
  }, [
    fields,
    totalSeed,
    totalAcres,
    UNIT_SIZE
  ])

  return (
    <Widget title='Units needed'>
      {loadingStatus === 'LOADING' || loadingStatus === 'WAITING' ?
        (<TableStatus status={'LOADING'} />)
        : (
          <div className='df'>
            <div className='w50% mr25'>
              <div>
                <label className='fz15'>Average weighted planting rate</label>
                <div className='posr fz18 mt5'>
                  <input className='interff bd1-s-lightgray bgc-gray' value={weightedAverage} disabled={true} />
                  <div className='posa t10 r3% interff c-darkwhite'>seeds/acres</div>
                </div>
              </div>
              <div className='mt40'>
                <label className='fz15'>Unit size</label>
                <div className='posr fz18 mt5'>
                  <input className='interff bd1-s-lightgray bgc-gray' value={UNIT_SIZE} disabled={true} />
                  <div className='posa t10 r3% interff c-darkwhite'>seeds/unit</div>
                </div>
              </div>
            </div>
            <div className='w50% fw600 bd1-s-lightgray bdrs-4 p16'>
              <div className='interff mb16 c-darkgray'>ENOGEN UNITS NEEDED</div>
              <div className='fz28 df'>
                {unitsNeeded && <div>{unitsNeeded} Units</div>}
              </div>
            </div>
          </div>
        )
      }
    </Widget>
  )
}

export default EstimatedUnits